import { SxProps, Theme } from '@mui/material';
import theme from './theme';

export const BackdropSx = (theme: Theme) => ({
  color: '#fff',
  zIndex: theme.zIndex.drawer + 1,
});

export const StickyHeaderSx: SxProps<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: theme.zIndex.appBar,
  flexShrink: 0,
};
